// @flow

import type { CommentOperation, CommentOperationsById } from 'hfty-operator-comments/types'

import type { Crop } from 'fc-model-crops/types'

import type { Asset } from 'fc-model-assets/types'

// Libs
import React, { Component } from 'react'
import _reduce from 'lodash/reduce'
import _some from 'lodash/some'
import _size from 'lodash/size'

// Components
import DeleteComment from './DeleteComment'
import Button from '@react-mdc/button'
import FormField from '@react-mdc/form-field'

// Styles
const styles = {
  container: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    width: 300,
    backgroundColor: '#fff',
    color: '#fff',
    boxShadow: '-2px 0 2px rgba(0, 0, 0, 0.2)',
    padding: 15,
    overflow: 'auto',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    margin: '30px 0 10px 0',
  },
}

// types
type Props = {
  crops: Array<Crop>,
  fields: Array<Asset>,
  operations: CommentOperationsById,
  currentUserUnits: string,
  onCancel: Function,
  onSubmit: Function,
}

export default class DeleteComments extends Component {
  props: Props
  onSubmit: Function
  onCancel: Function

  constructor(props: Props) {
    super(props)

    this.onSubmit = this.onSubmit.bind(this)
    this.onCancel = this.onCancel.bind(this)
  }

  onSubmit(e: Event) {
    e.preventDefault()

    this.props.onSubmit(this.props.operations)
  }

  onCancel(e: Event) {
    e.preventDefault()

    this.props.onCancel(this.props.operations)
  }

  renderOperations(): Array<React.Element<any>> {
    return _reduce(
      this.props.operations,
      (acc: Array<React.Element<any>>, operation: CommentOperation): Array<React.Element<any>> => {
        if (operation.operation === 'DELETE') {
          acc.push(
            <DeleteComment
              key={operation.operationId}
              crops={this.props.crops}
              fields={this.props.fields}
              operation={operation}
              currentUserUnits={this.props.currentUserUnits}
            />
          )
        }
        return acc
      },
      []
    )
  }

  render(): ?React.Element<any> {
    const isDeleting = _some(this.props.operations, (o: CommentOperation): boolean => o.operation === 'DELETE')
    if (_size(this.props.operations) && isDeleting) {
      return (
        <form style={styles.container} onSubmit={this.onSubmit}>
          <FormField>
            <p>Are you sure you want to delete the following?</p>
          </FormField>
          {this.renderOperations()}
          <div style={styles.buttonsContainer}>
            <Button raised primary onClick={this.onSubmit}>
              {'Confirm'}
            </Button>
            <Button raised primary onClick={this.onCancel}>
              {'Cancel'}
            </Button>
          </div>
        </form>
      )
    }

    return null
  }
}
